import { createStyles, makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import { Button } from "@material-ui/core";

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    title: {
      flexGrow: 1,
    },
    cardRoot: {
      maxWidth: 200,
      textTransform: "capitalize",
      margin: "1rem auto",
    },
    cardUserRoot: {
      maxWidth: 1000,
      margin: "2rem auto",
      [theme.breakpoints.down("sm")]: {
        margin: "2rem 1rem",
      },
    },
    repoUserRoot: {
      maxWidth: 1000,
      margin: "0.5rem auto",
      [theme.breakpoints.down("sm")]: {
        margin: "2rem 0.5rem",
      },
    },
    cardUserImageContainer: {
      display: "flex",
      height: "100%",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    cardUserImage: {
      width: 200,
      height: 200,
      borderRadius: "50%",
      margin: "1.5rem",
    },
    cardRoundedImage: {
      width: 100,
      height: 100,
      borderRadius: "50%",
      margin: "1rem auto 0.5rem",
    },
    cardContent: {
      display: "flex",
      flexDirection: "column",
      padding: "1rem",
    },
    searchRoot: {
      width: "80%",
      margin: "1rem auto",
    },
    searchBtn: {
      margin: "1rem 0",
    },
    navLink: {
      color: "#fff",
      textDecoration: "none",
      margin: "auto",
    },
    textSuccess: {
      color: "#0f0",
    },
    textDanger: {
      color: "#f00",
    },
    listRoot: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    reposContainer: {
      marginTop: "2rem",
    },
  })
);

export const StyledButton = styled(Button)`
  background-color: ${(props) =>
    props.styletype === "contained" ? props.bgcolor : "inherit"};
  color: ${(props) =>
    props.styletype !== "contained" ? props.bgcolor : props.textcolor};
  border: ${(props) => {
    return props.styletype === "outlined"
      ? "2px solid " + props.bgcolor
      : "inherit";
  }};
  padding:"1rem auto"
  margin: "1rem 0rem";
  border-radius: "8px";
  text-transform: none;
  white-space: nowrap;
  font-size: 1rem;

  &:hover {
    background-color: ${(props) =>
      props.styletype === "contained" ? props.hovercolor : "inherit"};
    color: ${(props) =>
      props.styletype !== "contained" ? props.hovercolor : props.textcolor};
    border: ${(props) => {
      return props.styletype === "outlined"
        ? "2px solid " + props.hovercolor
        : "inherit";
    }};
  }
`;
